import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { dateFormat } from '~utils/dateTime';

interface CreatedColumnProps {
  boldTime?: boolean;
  // When the ticket reached Tread, not when the driver captured it — the driver app
  // captures offline and syncs later.
  createdAt?: string;
  sx?: SxProps<Theme>;
}

export default function CreatedColumn({
  boldTime = false,
  createdAt,
  sx,
}: CreatedColumnProps) {
  const timeString = createdAt ? dateFormat(createdAt, 'h:mm A') : '-';
  const dateString = createdAt ? dateFormat(createdAt, 'MMM D, YYYY') : '-';

  return (
    <Box sx={sx}>
      <OverflowAwareText sx={{ ...(boldTime ? { fontWeight: 600 } : {}) }}>
        {timeString}
      </OverflowAwareText>
      <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
        {dateString}
      </OverflowAwareText>
    </Box>
  );
}
